export function ImportResultDialog({ result, testPrefix, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid={`${testPrefix}-import-result-dialog`}>
      <div className="max-h-[80vh] w-full max-w-lg overflow-auto rounded-md bg-white p-5 shadow-xl">
        <h3 className="text-base font-bold text-slate-900">Import summary</h3>
        <p className="mt-1 text-sm text-slate-600" data-testid={`${testPrefix}-import-result-summary`}>
          {result.added} added · {result.skipped_rows.length} skipped out of {result.total_rows} rows
        </p>
        <table className="mt-3 w-full text-left text-xs">
          <thead>
            <tr className="border-b border-slate-200 text-slate-500">
              <th className="py-1.5 pr-2 font-semibold">Skipped row</th>
              <th className="py-1.5 font-semibold">Reason</th>
            </tr>
          </thead>
          <tbody>
            {result.skipped_rows.map((r) => (
              <tr key={r.name} className="border-b border-slate-100">
                <td className="py-1.5 pr-2 font-medium text-slate-800">{r.name}</td>
                <td className="py-1.5 text-slate-600">{r.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <button data-testid={`${testPrefix}-import-result-close`} onClick={onClose}
          className="mt-4 rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors duration-150 hover:bg-slate-700">
          Close
        </button>
      </div>
    </div>
  );
}
